import * as React from 'react'

import style from './spinner.style'

type Props = {
  className?: string,
}

export type StyleProps = {
  kind: 'small' | 'medium' | 'large',
}

const styleProps = ({ kind }: StyleProps): StyleProps => ({
  kind: kind || 'medium',
})

const Spinner = ({ className }: Props): React.ReactElement<'svg'> => (
  <svg {...{ className }} data-testid="spinner" xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" color="currentColor">
    <path
      fillRule="nonzero"
      d="M42 24c0-9.941-8.059-18-18-18S6 14.059 6 24s8.059 18 18 18v6C10.745 48 0 37.255 0 24S10.745 0 24 0s24 10.745 24 24a3 3 0 0 1-6 0z"
    />
  </svg>
)

Spinner.defaultProps = {
  className: undefined,
}

export default style(Spinner, styleProps)
